import { FormattedMessage } from "react-intl";
import ReactHtmlParser from "react-html-parser";

import { getLabelWithTranslationFallback } from "helpers/getLabel";
import Card from "components/v2/Card/Card";
import { replaceLinebreaks } from "helpers/commonHelpers";
import { replaceLinks } from "helpers/urlHelpers";

type CustomLongfieldProps = {
  customLongfield: string;
};

function CustomLongfield(props: CustomLongfieldProps) {
  const { customLongfield } = props;

  return (
    <div>
      <Card borderRadius="md">
        <Card.Header
          title={getLabelWithTranslationFallback("Custom longfield 01", {
            style: "capitalize",
            translation: (
              <FormattedMessage
                id="new-request.quote-confirmation.organisation.customLongfield1"
                defaultMessage="Custom longfield 1"
              />
            ),
          })}
          showBorder
        />
        <div className="py-xl px-3xl">{ReactHtmlParser(replaceLinebreaks(replaceLinks(customLongfield)))}</div>
      </Card>
    </div>
  );
}

export default CustomLongfield;
